import { alpha } from "@mui/material"
import { makeStyles } from "tss-react/mui"

interface StyleProps {
  color?: string
  borderColor?: string
}

export const useStyles = makeStyles<StyleProps>()(
  ({ spacing, palette }, { color, borderColor }) => {
    const baseColor = color || palette.primary[50]
    // Use provided borderColor or use default
    const computedBorderColor = borderColor || palette.secondary[300]
    return {
      helpArticlesContainer: {
        padding: spacing(5),
        borderRadius: "6px",
        border: `1px solid ${computedBorderColor}`,
        backgroundColor: alpha(baseColor, 0.5)
      },
      helpArticlesIconContainer: {
        width: "60px",
        height: "60px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "50%",
        backgroundColor: palette.secondary[100]
      },
      customLinkColor: {
        color: palette.secondary[700]
      }
    }
  }
)
